
<template>
<div>
  <v-layout wrap>
    <v-flex>
      <v-btn color="primary"  @click="dialog=true" style="width: 100%; font-weight: bolder;">
        Severity factor
      </v-btn>
    </v-flex>
  </v-layout>
  <v-layout wrap style="text-align: center; font-weight: bolder;">
    <v-flex md6 class="pa-4">
      <fs1-div>Nivel de severidad</fs1-div>
      <fs1-div style="color:orangered">{{selectedItem.nivel||0}}</fs1-div>
    </v-flex>
    <v-flex md6 class="pa-4">
      <fs1-div>Factor de severidad</fs1-div>
      <fs1-div style="color:orangered">{{selectedItem.factor||0}}</fs1-div>
    </v-flex>
  </v-layout>


  <v-dialog v-model="dialog" persistent max-width="700">
    <v-card flat class="fullHeight pa-40 textAlignCenter">
      <h2>Tabla de severidad y probabilidad</h2>
      <br>
      <table class="mflTable">
        <thead>
          <tr>
            <th v-for="(v,i) in title_keys" :key="i">{{titles[v]}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(v, i) in values"
            :key="i"
            @click="set(v[title_keys[2]])"
            :class="getClass(v[title_keys[2]])">
            <td v-for="(k,ii) in title_keys" :key="ii">
              <fs1-span>{{v[k]}}</fs1-span>
            </td>
          </tr>
        </tbody>
      </table>
      <br>
      <div>
        <v-btn color="secondary" @click="dialog = false">
          <v-icon></v-icon>
          <span>Cerrar</span>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import { SXP_values as values, SXP_titles as titles } from '@/objects/general.js';

export default {
  props: ['value','disabled'],
  data() {
    return {
      dialog:false,
      values,
      titles,
    };
  },
  computed:{
    title_keys(){ return Object.keys(this.values[0]) },
    selectedItem(){ return this.values.find(s=>s.factor===this.value)||{}}
  },
  methods: {
    set(v){ 
      if(!this.disabled) this.$emit('update:value', v);
      this.dialog = false;
    },
		getClass(v){
			if (this.value === v) return 'selected';
			if (this.disabled) return 'disabled';
			return '';
    },
  }, // methods
};
</script>
